import api from '../../api'
const state = {
  regions: []
}
// class Region {
//   name;
// }

// class Country {
//   name;
// }

// class Chapter {
//   name;
//   info;
// }

// class RegionsState {
//   regions;
// }

const mutations = {
  setRegions(state, payload) {
    state.regions = payload
  }
}

const actions = {
  async loadRegions({ commit, rootState, state }) {
    if (!state.regions.length) {
      rootState.loading = true
    }

    const response = await api.getRegions()
    const regions = response && response.data
    commit('setRegions', regions)
    rootState.loading = false
  }
}
const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
